// constants
import { BOOKING_NATURE_VALUE_PAR } from "../../constants/booking";

function getOptions({ optionList, roomOptionList }) {
  const newOptions = {};

  for (const option of optionList) {
    if (
      // S’il s’agit d’une option optionnelle.
      roomOptionList.some(function (roomOption) {
        return roomOption.id === option.id;
      })
    ) {
      newOptions[option.id] = option.booking_quantity;
    }
  }

  return newOptions;
}

export function normalizeParameterListForEstimate({
  parameterList,
  roomOptionList,
}) {
  const nature = parameterList?.nature || BOOKING_NATURE_VALUE_PAR;

  const childs = parameterList?.childs ?? 0; // 😤 “childs”

  const cats = (parseInt(parameterList?.cats) || 0) ?? 0;
  const dogs = (parseInt(parameterList?.dogs) || 0) ?? 0;
  const other_pets = (parseInt(parameterList?.other_pets) || 0) ?? 0;
  const pets = cats + dogs + other_pets;

  return {
    roomRef: parameterList?.roomReference,
    channelId: parameterList?.channelId,
    checkin: parameterList?.checkin,
    checkout: parameterList?.checkout,
    adults: parameterList?.adults ?? 0,
    childs,
    babies: parameterList?.babies ?? 0,
    pets,
    dogs,
    cats,
    nature,
    source: parameterList?.source,
    useDefaultOptions: "1",
    options: getOptions({
      optionList: parameterList?.optionList ?? [],
      roomOptionList,
      nature,
    }),
    discountCodes: parameterList?.discountCodeList ?? [],
    insuranceId: parameterList?.insuranceId ?? "",
    discountCodeList: undefined,
    optionList: undefined,
    roomReference: undefined,
  };
}

export function normalizeParameterListForAio({
  parameterList,
  roomOptionList,
}) {
  const nature = parameterList?.nature || BOOKING_NATURE_VALUE_PAR;

  const childs = parameterList?.childs ?? 0; // 😤 “childs”

  const cats = (parseInt(parameterList?.cats) || 0) ?? 0;
  const dogs = (parseInt(parameterList?.dogs) || 0) ?? 0;
  const other_pets = (parseInt(parameterList?.other_pets) || 0) ?? 0;
  const pets = cats + dogs + other_pets;

  return {
    ...parameterList,
    roomRef: parameterList?.roomReference,
    selectionId: parameterList?.selectionId,
    adults: parameterList?.adults ?? 0,
    childs,
    babies: parameterList?.babies ?? 0,
    birthyears: (parameterList?.birthyears ?? []).slice(0, childs),
    pets,
    dogs,
    cats,
    nature,
    useDefaultOptions: "1",
    options: getOptions({
      optionList: parameterList?.optionList ?? [],
      roomOptionList,
      nature,
    }),
    discountCodes: parameterList?.discountCodeList ?? [],
    insuranceId: parameterList?.insuranceId ?? "",
    discountCodeList: undefined,
    optionList: undefined,
    roomReference: undefined,
    createJwt: !(parameterList?.logged ?? false) ? "1" : undefined,
  };
}
